import { Fragment } from 'react';

import DataGrid from '@/components/elements/lists/DataGrid';
import { _t } from '@/locale';
import { CheckoutDetailsService } from '@/types/checkout';

type Props = {
  baseTranslationKey:
    | 'components.modules.checkout.CheckoutDetails'
    | 'components.modules.appointment.AppointmentDetailsSummary';
  services?: CheckoutDetailsService[];
};

const PaymentDetailsServicesList = ({ baseTranslationKey, services }: Props) => {
  if (!services || services.length === 0) {
    return null;
  }

  return (
    <>
      {services?.map((service, index) => {
        const discount = service.discount;
        const amount = service?.amount ?? 0;
        const translationKey = amount === 1 ? 'usageRemaining' : 'usagesRemaining';
        const servicePrice = service.price.replace(_t('from'), _t('Fr.'));
        return (
          <Fragment key={service.name + index}>
            <DataGrid.Row key={index} hasPaddingTop>
              <DataGrid.Cell
                title={service.name}
                type="default"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.name`)}
                truncate
              />
              <DataGrid.Cell
                title={discount ? <span className="text-fg_highlight">{discount}</span> : servicePrice}
                align="right"
                ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.price`)}
                nowrap
              />
            </DataGrid.Row>

            <DataGrid.Row underline>
              {service.duration && (
                <DataGrid.Cell
                  title={
                    <span className="gap-sm flex flex-nowrap items-center">
                      <span className="text-nowrap">{service.duration}</span>
                      {service?.onRemove && (
                        <button className="text-fg_negative text-nowrap underline" onClick={() => service.onRemove()}>
                          {_t(`${baseTranslationKey}.removeServiceItem`)}
                        </button>
                      )}
                    </span>
                  }
                  type="description"
                  ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.duration`)}
                />
              )}
              {discount && (
                <DataGrid.Cell
                  title={<span className="text-fg_secondary line-through">{servicePrice}</span>}
                  type="description"
                  ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.price`)}
                  align="right"
                />
              )}
              {service?.amount && (
                <DataGrid.Cell
                  title={
                    <span className="text-nowrap text-fg_secondary">
                      {_t(`bundleCheckout.${translationKey}`, { amount })}
                    </span>
                  }
                  type="description"
                  ariaLabel={_t(`${baseTranslationKey}.ariaLabel.service.duration`)}
                  align="right"
                />
              )}
            </DataGrid.Row>
          </Fragment>
        );
      })}
    </>
  );
};

export default PaymentDetailsServicesList;
